// extracted by mini-css-extract-plugin
module.exports = {"root":"c8LS6t7"};